module.exports = __webpack_public_path__ + "static/img/xiazai_duan.aa0925b0.png";